module.exports = "# Sharknado\n\nYouTube: _JRlG-5_7ic\n\n## Notes\n\nSara and Ian share what should go in your Apprentices' emergency kits (4:16).\n\n# Calming Breath Recap\n\nYouTube: nUGO4-S_I5w\n\n## Notes\n\nPractice the Superhero Calming Breath! (0:36).\n\n# Esmeralda and Goober Story\n\nYouTube: 5FvPTip5iI4\n\n## Notes\nEsmeralda and Goober storyline - Get a Kit (2:37).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsPrimaries/sections/11_esGooberStory/level3_egstory.md
// module id = 1633
// module chunks = 2